import { useAppSelector } from '@/shared/hooks';
import { ImageConfig } from 'konva/lib/shapes/Image';
import { Image, KonvaNodeEvents } from 'react-konva';
import useImage from 'use-image';

export function FrameImage({
  ...props
}: Omit<ImageConfig, 'image'> & KonvaNodeEvents) {
  const frameImage = useAppSelector(
    (state) =>
      state.collection.framesList[state.collection.selectedFrameIndex]?.image
  );
  const [image] = useImage(frameImage);

  if (!frameImage) return;

  return (
    <Image
      width={1920 / 2}
      height={1080 / 2}
      fit="contain"
      {...props}
      image={image}
    />
  );
}
